import PropTypes from "prop-types";
import { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { crearRestriccion } from "../../services/restriccion-service";
import { selectSoftware } from "../../services/software-service";

const FormRestricciones = ({ modalState, onSave }) => {
    const [software, setSoftware] = useState([]);

    useEffect(async () => {
        const resp = await selectSoftware();
        if (!resp.status) return toast.error(resp.message);

        setSoftware(
            resp.data.map((software) => {
                return {
                    label: software.nombre,
                    value: software.id,
                };
            })
        );
    }, []);

    const form = useForm();

    const onCreateRestricciones = async (restricciones) => {
        const resp = await crearRestriccion({
            ...restricciones,
            software_id: restricciones.software_id.value,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formRestricciones"
            isOpen={modalState.show}
            onSubmit={onCreateRestricciones}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={12}>
                    <SelectController
                        errors={form.formState.errors}
                        name="software_id"
                        label="Software"
                        control={form.control}
                        options={software}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        label="Restricción"
                        errors={form.formState.errors}
                        control={form.control}
                        name="restriccion"
                        placeholder="Restricción"
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormRestricciones.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormRestricciones;
